export const PAGE_ENUM = {
  TASK_LIST: 'task_list',
  CHEMICAL_LIST: 'chemical_list',
  FERTILIZER_LIST: 'fertilizer_list',
};
